module.exports = __webpack_public_path__ + "media/images/flags/ls-b39b25771d35068f3c94dd8407cf4240.svg";